export const SHOW_TEST_DRIVE_LOADER = "SHOW_TEST_DRIVE_LOADER"
export const HIDE_TEST_DRIVE_LOADER = "HIDE_TEST_DRIVE_LOADER"

export const TEST_DRIVE_SENT = 'TEST_DRIVE_SENT'
export const TEST_DRIVE_SEND_FAILED = 'TEST_DRIVE_SEND_FAILED'


// WEBPACK FOOTER //
// ./src/store/testDrives/actionTypes.js